import { FC } from "react";

import { IconCheckmark } from "@/components/_icons/IconCheckmark";

import { IndicatorFrequency } from "../models/indicator-frequency-model";

import { IndicatorFrequencyView } from "./indicator-frequency-view";

export interface IndicatorFrequencySelectDropdownItemProps {
  frequency: IndicatorFrequency | null;
  selected?: boolean;
}

export const IndicatorFrequencySelectDropdownItem: FC<IndicatorFrequencySelectDropdownItemProps> = ({
  frequency,
  selected,
}) => {
  return (
    <div
      className="m-1 flex w-full cursor-pointer flex-row items-center justify-between p-1 text-xs"
      role="option"
      aria-selected={selected}
    >
      <IndicatorFrequencyView frequency={frequency} />
      {selected && <IconCheckmark className="h-3 w-3 shrink-0 text-foreground/60" />}
    </div>
  );
};
